<template>
  <div class="page-content">
    <div>
      <div class="page-title">Ten years to transform our world - The UN Decade of Action</div>
      <div class="text">
        The Decade of Action calls for accelerating sustainable solutions to all the world’s biggest
        challenges — ranging from poverty and gender to climate change, inequality and closing the
        finance gap.
      </div>
    </div>
    <img src="@/assets/images/splan/goals.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.mobile {
  .page-content {
    flex-wrap: wrap;
    .text {
      margin-top: 20px !important;
    }
    > img {
      width: 100% !important;
      height: max-content !important;
    }
  }
}
.page-content {
  display: flex;
  width: 100%;
  > img {
    width: fw(400vw, pc);
    height: fw(400vw, pc);
    display: block;
  }
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  .text {
    margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(31vh, pc);
  }
}
</style>
